import { createImmutableObjectClass } from 'immutable-less/ImmutableObject';
import * as ModuleQueryField from '../constants/ModuleQueryField';
import * as AssetSort from '../../common/constants/AssetSort';
export const DEFAULT_MODULE_QUERY_LIMIT = 24;
export const DEFAULT_MODULE_SORT_VALUE = AssetSort.INSTALL_COUNT_DESC;
export const MODULE_QUERY_FIELD_NAMES = Object.values(ModuleQueryField);
export const MODULE_QUERY_FILTER_ORDER = ['categories', 'planType', 'priceRange', 'portalCompatible', 'tiers', 'minOverallRating', 'hasFreeSupport', 'providers', 'tags'];
const defaults = {
  categories: [],
  hasFreeSupport: null,
  limit: DEFAULT_MODULE_QUERY_LIMIT,
  minReviewCount: null,
  minOverallRating: null,
  offeringIds: [],
  offset: 0,
  planType: null,
  portalCompatible: null,
  priceRange: null,
  providers: [],
  search: null,
  sortFields: [],
  tags: [],
  templateType: [],
  tiers: []
};
export class ModuleQuery extends createImmutableObjectClass(defaults) {}